// TestContent.js
import React from 'react';

const Roles = () => {
  return (
    <div>
      <h1>Roles</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Roles;
